<template>
    <div class="content">
        <dynamic-table
            :table-data="markerData"
            :show-footer="false"
            :show-footer-legend="false"
            :show-dot-column="false"
            @row-clicked="tableRowClicked"
        />
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-facing-decorator"
    import DynamicTable from "@/components/DynamicTableResponsive.vue"
    import TableData from "@/models/tabledata"
    import DynamicModalData from "@/models/dynamicmodaldata"

    @Component({
        components: {
            "dynamic-table": DynamicTable
        }
    })
    export default class Rekisterointitoimipaikat extends Vue {
        /** Haetaan palvelupisteiden määrät storesta ja näytetään ne taulukossa. Määrät lasketaan kartan piirron yhteydessä.(Map.vue / countVisibleMarkers) */
        get markerData() {
            const markers = this.$store.getters.visibleMarkers as Map<string, number> | null
            const tableValues: Map<string[], boolean> = new Map()
            tableValues.set([this.$t("App.VesiLiikenne.yleisetpisteet") ?? "", markers?.get("yleisetpisteet")?.toString() ?? "0"], false)
            tableValues.set([this.$t("App.VesiLiikenne.omatrekisteroinnit") ?? "", markers?.get("omatrekisteroinnit")?.toString() ?? "0"], false)

            return new TableData(this.tableColumHeaders, null, tableValues)
        }

        get tableColumHeaders(): string[] {
            const columns: string[] = []
            columns.push(this.$t("App.VesiLiikenne.Palvelupiste") ?? "App.VesiLiikenne.Palvelupiste")
            columns.push(this.$t("App.VesiLiikenne.Määrä") ?? "App.VesiLiikenne.Määrä")
            return columns
        }

        tableRowClicked(row: number) {
            let type = ""
            let header = ""
            // haetaan näkyvien markkeireiden datat
            const markersData = this.$store.getters.markersData as Map<string, string> | null
            const markers = this.$store.getters.visibleMarkers as Map<string, number> | null
            // haetaan vain valitun rivin/tyyppin datat /luotetaan tässä kohtaa rivin numerointiin ja järjestykseen
            if (row === 0) {
                // YleisetPisteet
                type = "yleisetpisteet"
                header = this.$t("App.VesiLiikenne.yleisetpisteet") ?? ""
            }
            else {
                // OmatRekisteroinnit
                type = "omatrekisteroinnit"
                header = this.$t("App.VesiLiikenne.omatrekisteroinnit") ?? ""
            }
            const textContent = markersData?.get(type) ?? ""
            const count = markers?.get(type) ?? null
            // avataan modaali tarkempien tietojen näyttämiseksi
            const modalData = new DynamicModalData(type, header, textContent, count)
            this.$store.dispatch("setModalData", modalData)
            this.openModal()
        }

        openModal() {
            this.$store.dispatch("setModalComponentName", "RekisterointitoimipaikatModal")
        }
    }

</script>
<style scoped>
    .dropdowns {
        margin-bottom: 20px;
    }
</style>
